import * as React from "react";
import { Button } from "carbon-components-react";
import { Renew16 } from "@carbon/icons-react";
import { connect } from "react-redux";

import HurdleView from "underwriter_dashboard/shared/HurdleView";
import { HurdleProps } from "underwriter_dashboard/HurdleEditor";
import BorrowerEmailUpdater from "../BorrowerEmailUpdater";
import SSNEditModalButton from "../../shared/SSNEditModalButton";
import WorksheetEditor from "../../shared/WorksheetEditor";
import { loadApp } from "../../actions";

import DependentsAgesEditor from "./DependentsAgesEditor";
import ExpectedGrossMonthlyRentalIncome from "./ExpectedGrossMonthlyRentalIncomeEditor";
import BorrowersEditor from "./BorrowersEditor";

const hurdleStyles = require("../styles.module.scss");
const styles = require("./styles.module.scss");

interface HurdleEditorProps extends HurdleProps {
  dispatch?: Function;
}

class PersonalInfo extends React.Component<HurdleEditorProps, any> {
  reloadApp() {
    // eslint-disable-next-line react/destructuring-assignment
    loadApp(this.props.dispatch, this.props.app.id);
  }

  render() {
    const { app, hurdle, onHide } = this.props;

    return (
      <HurdleView app={app} hurdle={hurdle} onHide={onHide}>
        <div className="dashboard-container">
          <div className={styles.container}>
            <BorrowerEmailUpdater borrowerId={app.borrower_id} />
            <SSNEditModalButton appID={app.id} borrowers={app.borrowers} />
            <BorrowersEditor app={app} />
            <WorksheetEditor
              appId={app.id}
              loanFileWsId={app.loan_file_worksheet_id}
              openToWsName="borrower_estimates"
              showChildrenInline
            />
            <div className={styles.singleFieldFormsContainer}>
              <DependentsAgesEditor app={app} reloadApp={this.reloadApp.bind(this)} />
              <ExpectedGrossMonthlyRentalIncome app={app} reloadApp={this.reloadApp.bind(this)} />
            </div>
          </div>

          <footer className={hurdleStyles.footer}>
            <Button kind="tertiary" onClick={this.reloadApp.bind(this)} renderIcon={Renew16}>
              Reload
            </Button>
          </footer>
        </div>
      </HurdleView>
    );
  }
}

export default connect<any, any, any>(null, null, null)(PersonalInfo);
